var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 22 22",
        fill: "currentColor",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M16.6459 19.2832H2.59857V5.2832H11.629V3.2832H2.59857C1.49484 3.2832 0.591797 4.1832 0.591797 5.2832V19.2832C0.591797 20.3832 1.49484 21.2832 2.59857 21.2832H16.6459C17.7497 21.2832 18.6527 20.3832 18.6527 19.2832V10.2832H16.6459V19.2832ZM8.82958 16.1132L6.86295 13.7532L4.10364 17.2832H15.1409L11.5889 12.5732L8.82958 16.1132ZM18.6527 3.2832V0.283203H16.6459V3.2832H13.6358C13.6458 3.2932 13.6358 5.2832 13.6358 5.2832H16.6459V8.2732C16.656 8.2832 18.6527 8.2732 18.6527 8.2732V5.2832H21.6629V3.2832H18.6527Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }